// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"resetPassword_ant-table-thead__7cta7","form-items-2":"resetPassword_form-items-2__jvtSD","form-input-block":"resetPassword_form-input-block__B1ZQq"};